import React from "react";

/* Icon set ported from CamcomOne-UI-draft-04.html. Stroked, 24x24, currentColor. */

const S = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  />
);

export const Icon = {
  Demo: () => (
    <S>
      <circle cx="12" cy="12" r="9" />
      <path d="M10 9l5 3-5 3z" />
    </S>
  ),
  Dash: () => (
    <S>
      <rect x="3" y="3" width="7.5" height="7.5" rx="1.5" />
      <rect x="13.5" y="3" width="7.5" height="7.5" rx="1.5" />
      <rect x="3" y="13.5" width="7.5" height="7.5" rx="1.5" />
      <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="1.5" />
    </S>
  ),
  Vid: () => (
    <S>
      <rect x="2.5" y="5" width="19" height="14" rx="2.5" />
      <path d="M2.5 9h19M7 5v4M17 5v4" />
    </S>
  ),
  Broc: () => (
    <S>
      <path d="M5 3.5h9l5 5V20a.5.5 0 01-.5.5h-13A.5.5 0 015 20z" />
      <path d="M14 3.5V9h5M8.5 13h7M8.5 16.5h5" />
    </S>
  ),
  Ppt: () => (
    <S>
      <rect x="3" y="4" width="18" height="12" rx="2" />
      <path d="M12 16v4M9 20h6" />
    </S>
  ),
  Case: () => (
    <S>
      <path d="M6 3.5h12a.5.5 0 01.5.5v16l-6.5-4-6.5 4V4a.5.5 0 01.5-.5z" />
    </S>
  ),
  Ext: () => (
    <S>
      <path d="M14 4h6v6M20 4l-8.5 8.5M18 14v5a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h5" />
    </S>
  ),
  Play: () => (
    <S>
      <path d="M7 5l12 7-12 7z" />
    </S>
  ),
  Open: () => (
    <S>
      <path d="M5 12h14M13 6l6 6-6 6" />
    </S>
  ),
  Plus: () => (
    <S>
      <path d="M12 5v14M5 12h14" />
    </S>
  ),
  Eye: () => (
    <S>
      <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z" />
      <circle cx="12" cy="12" r="3" />
    </S>
  ),
  Cam: () => (
    <S>
      <path d="M3 8.5h3.2l1.4-2.2h8.8l1.4 2.2H21a1 1 0 011 1v8a1 1 0 01-1 1H3a1 1 0 01-1-1v-8a1 1 0 011-1z" />
      <circle cx="12" cy="13.5" r="3.4" />
    </S>
  ),
  Vcam: () => (
    <S>
      <rect x="2.5" y="6.5" width="13" height="11" rx="2.2" />
      <path d="M15.5 11l5-3v8l-5-3z" />
    </S>
  ),
  Kit: () => (
    <S>
      <path d="M4 6h16M4 12h16M4 18h10" />
    </S>
  ),
  Share: () => (
    <S>
      <path d="M12 16V4M12 4L8 8M12 4l4 4M5 14v5a1 1 0 001 1h12a1 1 0 001-1v-5" />
    </S>
  ),
  Company: () => (
    <S>
      <circle cx="12" cy="8" r="3.2" />
      <path d="M5.5 19c.6-3.3 3.3-5 6.5-5s5.9 1.7 6.5 5" />
    </S>
  ),
};

/* Slot keys in the catalogue are lowercase; this maps them to the PascalCase components
   so dynamic lookups still satisfy react/jsx-pascal-case. */
export const SLOT_ICON = {
  demo: Icon.Demo, dash: Icon.Dash, vid: Icon.Vid,
  broc: Icon.Broc, ppt: Icon.Ppt, case: Icon.Case,
};

export const Chev = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.8" strokeLinecap="round">
    <path d="M9 5l7 7-7 7" />
  </svg>
);

export const Back = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.9" strokeLinecap="round">
    <path d="M15 5l-7 7 7 7" />
  </svg>
);

/* The "One" lockup: a ring with a gap, as drawn in the draft. */
export const OneMark = () => (
  <span className="one">
    <svg className="o" viewBox="0 0 20 20" aria-hidden="true">
      <circle cx="10" cy="10" r="7.4" fill="none" stroke="currentColor" strokeWidth="2.6"
        strokeLinecap="round" strokeDasharray="39.5 6.9" transform="rotate(-58 10 10)" />
    </svg>
    <span className="ne">ne</span>
  </span>
);

export default Icon;
